import { api as defaultApi } from './api';
import { actionCreators } from './actions';
import { bindActionCreators } from 'redux';
import { useDispatch } from 'react-redux';
import { useMemo } from 'react';
import { safeNumericString } from 'app/infrastructure/data/sanitize';

export function useActionCreators(api: any = defaultApi) {
  const dispatch = useDispatch();
  return useMemo(
    () => bindActionCreators(actionCreators(api), dispatch), 
    [dispatch, api]
  );
}

export function useSelectors(params: any, router: any) {
  return {
    caseNumber: safeNumericString(params.id) || 0,
    caseContextId: router.location.query && safeNumericString(router.location.query.caseContextId) || 0,
    entityPath: Object
      .keys(params)
      .filter(k => k.match(/^level\d$/) && !!params[k])
      .map(k => `/${params[k]}/${params[k+'Value']}`)
      .join('')
  };
}
